var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagAnguilla(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_14867)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8365 24.8365 32 16 32C7.1635 32 0 24.8365 0 16C0 16.0038 16 0.00175 16 0C24.8365 0 32 7.1635 32 16Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9572 16.0001H16C16 15.9857 16 15.9717 16 15.9573C15.9857 15.9716 15.9715 15.9858 15.9572 16.0001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8.34781C16 5.5325 16 3.68781 16 0H15.9973C7.16194 0.0015 0 7.16431 0 16H8.34781V11.2993L13.0485 16H15.9572C15.9715 15.9858 15.9858 15.9715 16.0001 15.9572C16.0001 14.8793 16.0001 13.9174 16.0001 13.0486L11.2992 8.34781H16Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09469 2.08691C5.59225 3.51185 3.51181 5.59223 2.08694 8.09466V16H6.26087V6.26098V6.26085H16C16 4.94441 16 3.69029 16 2.08691H8.09469Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 14.0325L10.3153 8.3479H8.34781V8.34803L15.9999 16H16C16 16 16 14.6433 16 14.0325Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0587 18.3421C27.5188 17.7091 27.8261 16.9361 27.8261 16V9.04346C27.2447 9.48021 26.5222 9.73909 25.7391 9.73909C24.6013 9.73909 23.5911 9.19265 22.9565 8.3479C22.3219 9.19265 21.3117 9.73909 20.1739 9.73909C19.3908 9.73909 18.6683 9.48015 18.0869 9.04359V16C18.0869 16.9361 18.3943 17.7091 18.8543 18.3421H27.0587Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6119 14.7095C25.8334 14.1691 26.0056 13.3793 26.0056 12.9863C26.0056 12.3547 25.1822 11.8428 25.1822 11.8428C25.1822 11.8428 24.3589 12.3547 24.3589 12.9863C24.3589 13.3794 24.5312 14.1692 24.7526 14.7095L24.2772 15.7827C24.5566 15.8963 24.862 15.9595 25.1823 15.9595C25.5026 15.9595 25.8079 15.8963 26.0874 15.7827L25.6119 14.7095Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3934 11.2346C21.8149 11.3129 21.0447 11.5589 20.7043 11.7554C20.1574 12.0712 20.1256 13.0401 20.1256 13.0401C20.1256 13.0401 20.9807 13.4972 21.5276 13.1814C21.8681 12.9849 22.4659 12.4409 22.8229 11.9789L23.9902 11.8539C23.9489 11.5553 23.8506 11.2592 23.6907 10.9819C23.5304 10.7046 23.3233 10.4716 23.0851 10.2864L22.3934 11.2346Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9933 15.7592C21.3503 16.221 21.9483 16.7649 22.2888 16.9615C22.8357 17.2773 23.6908 16.8203 23.6908 16.8203C23.6908 16.8203 23.6589 15.8513 23.1121 15.5355C22.7715 15.3389 22.0014 15.0932 21.4228 15.015L20.7311 14.0667C20.4931 14.2518 20.2858 14.4849 20.1256 14.762C19.9656 15.0394 19.8676 15.3353 19.8261 15.6342L20.9933 15.7592Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6826 18.0872C19.9819 20.1718 22.9569 20.8697 22.9569 20.8697C22.9569 20.8697 25.9319 20.1718 27.2312 18.0872H18.6826Z",
    fill: "#338AF3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_14867"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagAnguilla);
export default __webpack_public_path__ + "static/media/flag_anguilla.a02a242d7c7292c9fe5b61166c6f1465.svg";
export { ForwardRef as ReactComponent };